module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.nome.$error
    }
  }, [_c('label', [_vm._v("Nome da vacina*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.nome),
      expression: "model.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.tipo.$error
    }
  }, [_c('label', [_vm._v("Tipo*")]), _vm._v(" "), _c('dw-select', {
    attrs: {
      "options": _vm.tipos,
      "opt-text": "nome",
      "placeholder": "Selecione o tipo"
    },
    model: {
      value: (_vm.model.tipo),
      callback: function($$v) {
        _vm.$set(_vm.model, "tipo", $$v)
      },
      expression: "model.tipo"
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione o tipo")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Responsável")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.responsavel),
      expression: "model.responsavel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.model.responsavel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "responsavel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.data.$error
    }
  }, [_c('label', [_vm._v("Data*")]), _vm._v(" "), _c('input-datepicker', {
    attrs: {
      "disabled": false,
      "readonly": false,
      "group": false,
      "autoclose": true
    },
    model: {
      value: (_vm.model.data),
      callback: function($$v) {
        _vm.$set(_vm.model, "data", $$v)
      },
      expression: "model.data"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.peso.$error
    }
  }, [_c('label', [_vm._v("Peso em kg*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.peso),
      expression: "model.peso"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.model.peso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "peso", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.data_proxima.$error
    }
  }, [_c('label', [_vm._v("Data da próxima vacina*")]), _vm._v(" "), _c('input-datepicker', {
    attrs: {
      "disabled": false,
      "readonly": false,
      "group": false,
      "autoclose": true
    },
    model: {
      value: (_vm.model.data_proxima),
      callback: function($$v) {
        _vm.$set(_vm.model, "data_proxima", $$v)
      },
      expression: "model.data_proxima"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-vaccines-pet',
        params: {
          idCliente: this.$route.params.idCliente,
          id: this.$route.params.id
        }
      }
    }
  }, [_vm._v("Cancelar\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-syringe"
  }), _vm._v(" Vacina\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea36a3b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pets/vaccines/Form.vue
// module id = 898
// module chunks = 1